import i18n from 'i18next';


export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export const downloadDoc = (mimeType, fileData, incidentKey, fileNameDef) => {
    const blob = b64toBlob(fileData, mimeType);
    const downloadLink = document.createElement("a");
    const fileName = fileNameDef ? fileNameDef : `${incidentKey}_${i18n.t("incidents:pdfIncident.documentation")}}`;
    downloadLink.download = fileName;
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.click();
};



